export default __webpack_public_path__ + "4c341ba50fb2faedde83ed28b332a591.svg";